import React from "react"
import {Modal, ModalProps} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

type Props = ModalProps & {
    mobileHeight: number
    desktopHeight: number
}

/*
 * Title: Using to style top !important
 * problem: we do not want to use !important but we want a modal and a modal is expected to cover the entire screen
 * in this case however, material UI probably assumes you'll have the entire screen covered and uses inline styles
 * to define this behaviour. But here the modal as it is the case of next, partially exposes the header area hence it
 * does not fully cover the entire screen.
 * Solution: for now we have to use !important
 * Refs:
 *    https://github.com/mui-org/material-ui/issues/16441
 *    https://github.com/mui-org/material-ui/issues/16442
 */

const opts = {shouldForwardProp: p => p !== "mobileHeight" && p !== "desktopHeight"}

export const Container = styled(({...rest}: ModalProps) => <Modal {...rest} />, opts)<Props>`
    transition: opacity 0.2s ease;
    animation-delay: 250ms;

    & > div:first-of-type {
        position: fixed;
    }

    && > div:first-of-type {
        background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    }

    @media (min-width: ${breakpoints.values.md}px) {
        .MuiBackdrop-root {
            top: ${props => props.desktopHeight}rem !important;
        }
    }
`
